import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-790ff241"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col mb-1" }
const _hoisted_3 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_4 = { class: "align-items-center d-flex flex-wrap justify-content-between w-100 ml-3" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "mb-0 lead" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { class: "panel-content" }
const _hoisted_14 = { class: "text-bold mb-0" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "panel-content" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = { class: "panel-content" }
const _hoisted_28 = { style: {"flex":"2"} }
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = {
  key: 0,
  class: "text-primary mb-1"
}
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "m-0 ml-1" }
const _hoisted_35 = { style: {"flex":"3"} }
const _hoisted_36 = ["href"]
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "d-flex" }
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = { class: "panel-content" }
const _hoisted_41 = {
  class: "text-preline",
  style: {"word-break":"break-word"}
}
const _hoisted_42 = { class: "align-items-center d-flex justify-content-between w-100" }
const _hoisted_43 = { class: "mb-0" }
const _hoisted_44 = { class: "panel-content w-50" }
const _hoisted_45 = { class: "map-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_StatusBadge = _resolveComponent("StatusBadge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProductConfigurationSummaryItem = _resolveComponent("ProductConfigurationSummaryItem")!
  const _component_ColumnYesNo = _resolveComponent("ColumnYesNo")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_GMapMap = _resolveComponent("GMapMap")!
  const _component_ExpertAcceptBookingModal = _resolveComponent("ExpertAcceptBookingModal")!
  const _component_ExpertCompleteBookingModal = _resolveComponent("ExpertCompleteBookingModal")!
  const _component_ExpertDeclineBookingModal = _resolveComponent("ExpertDeclineBookingModal")!
  const _component_ExpertReviewBookingModal = _resolveComponent("ExpertReviewBookingModal")!
  const _component_ExpertReviewBookingDetailsModal = _resolveComponent("ExpertReviewBookingDetailsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BackButton, {
      class: "mb-3",
      label: _ctx.$t('expert.button.back')
    }, null, 8, ["label"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Panel, {
          class: "mb-2",
          toggleable: false
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(_component_StatusBadge, {
                  status: _ctx.vm.booking.status,
                  "translation-prefix": "enum.expertBookingStatus",
                  type: 1
                }, null, 8, ["status"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.vm.pageTitle), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("expert.booking.subTitle")), 1)
                ]),
                (_ctx.isExpert && _ctx.showAcceptOrDeclineButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_Button, {
                        class: "p-button-success",
                        label: _ctx.$t(`common.accept`),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAcceptClick()))
                      }, null, 8, ["label"]),
                      _createVNode(_component_Button, {
                        class: "p-button-danger ml-1",
                        label: _ctx.$t(`common.reject`),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDeclineClick()))
                      }, null, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isExpert && _ctx.showCompleteButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_Button, {
                        class: "p-button-success",
                        label: _ctx.$t(`common.complete`),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCompleteClick()))
                      }, null, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showCancelButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_Button, {
                        class: "p-button-secondary",
                        label: _ctx.$t(`common.cancel`),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCancelClick()))
                      }, null, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showReviewButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_Button, {
                        class: "p-button-primary p-button-outlined",
                        label: _ctx.$t(`expert.button.${_ctx.bookingHasReview ? 'seeReview' : 'reviewBooking'}`),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onReviewClick()))
                      }, null, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isExpert && _ctx.showInvoiceButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_Button, {
                        class: "p-button-secondary",
                        icon: "pi pi-file-pdf",
                        label: _ctx.$t(`expert.button.viewInvoice`),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onViewInvoiceClick()))
                      }, null, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                (!_ctx.isExpert)
                  ? (_openBlock(), _createBlock(_component_ProductConfigurationSummaryItem, {
                      key: 0,
                      content: _ctx.vm?.booking?.expertDisplayName,
                      label: _ctx.$t('expert.booking.expert')
                    }, null, 8, ["content", "label"]))
                  : (_openBlock(), _createBlock(_component_ProductConfigurationSummaryItem, {
                      key: 1,
                      content: _ctx.vm?.booking?.customerContactDisplayName,
                      label: _ctx.$t('expert.booking.customer')
                    }, null, 8, ["content", "label"])),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  content: _ctx.vm?.booking?.workLocation || _ctx.$t('expert.remote'),
                  label: _ctx.$t('expert.booking.workLocation')
                }, null, 8, ["content", "label"]),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  label: _ctx.$t('expert.flexBooking')
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_ColumnYesNo, {
                      value: _ctx.vm?.isFlexBooking
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  label: _ctx.$t('expert.booking.dates')
                }, {
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDates(_ctx.vm?.booking.dates), (date) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: JSON.stringify(date),
                        class: "d-flex flex-column"
                      }, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(`${_ctx.formatDate(date.date)} `), 1),
                        _createElementVNode("small", null, _toDisplayString(`${_ctx.formatTime(date.start)} - ${_ctx.formatTime(date.end)}`), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              (_ctx.showExpertReward)
                ? (_openBlock(), _createBlock(_component_Divider, {
                    key: 0,
                    layout: _ctx.isSmallScreen ? 'horizontal' : 'vertical',
                    style: {"flex":"0"}
                  }, null, 8, ["layout"]))
                : _createCommentVNode("", true),
              (_ctx.showExpertReward)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.isExpert ? _ctx.$t("expert.booking.reward") : _ctx.$t("expert.booking.costs")), 1),
                    (!_ctx.isSpinnerVisible('priceSummary'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_PriceSummary, {
                            vm: _ctx.getPriceSummary(_ctx.expertBookingCosts)
                          }, null, 8, ["vm"])
                        ]))
                      : (_ctx.isSpinnerVisible('priceSummary'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (_ctx.isExpert)
          ? (_openBlock(), _createBlock(_component_Panel, {
              key: 0,
              class: "mb-2",
              toggleable: false
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t("expert.booking.titleCustomerInfo")), 1)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_ProductConfigurationSummaryItem, {
                    content: _ctx.vm?.booking?.customerContactDisplayName,
                    label: _ctx.$t('common.forms.lblName')
                  }, null, 8, ["content", "label"]),
                  _createVNode(_component_ProductConfigurationSummaryItem, {
                    label: _ctx.$t('common.forms.lblPhoneNumber')
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("a", {
                        href: `tel:${_ctx.vm.booking?.expertPhoneNumber}`
                      }, _toDisplayString(_ctx.vm.booking?.expertPhoneNumber), 9, _hoisted_23)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_ProductConfigurationSummaryItem, {
                    content: _ctx.vm?.booking?.customerContactEmail,
                    label: _ctx.$t('common.forms.lblEmail')
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("a", {
                        href: `mailto:${_ctx.vm.booking?.customerContactEmail}`
                      }, _toDisplayString(_ctx.vm.booking?.customerContactEmail), 9, _hoisted_24)
                    ]),
                    _: 1
                  }, 8, ["content", "label"])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Panel, {
              key: 1,
              class: "mb-2",
              toggleable: false
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t("expert.booking.titleExpertInfo")), 1)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Avatar, {
                        class: "mr-2 profile-image",
                        image: _ctx.expertProfile?.imageUrl,
                        shape: "circle",
                        size: "xlarge"
                      }, null, 8, ["image"]),
                      _createElementVNode("div", null, [
                        (_ctx.vm?.expert?.title)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_30, _toDisplayString(_ctx.vm?.expert?.title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_PopoverIcon, {
                            "open-delay": 500,
                            placement: "right"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("p", {
                                class: "text-bold",
                                innerHTML: _ctx.vm?.expert?.displayName
                              }, null, 8, _hoisted_32),
                              _createElementVNode("div", {
                                innerHTML: _ctx.vm?.expert?.description
                              }, null, 8, _hoisted_33)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Avatar, {
                                alt: _ctx.vm?.expert?.displayName,
                                class: "expert-badge",
                                image: _ctx.vm?.booking?.expertProduct?.iconUrl,
                                shape: "circle"
                              }, null, 8, ["alt", "image"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.vm?.expert?.function), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(_component_Divider, {
                    layout: "vertical",
                    style: {"flex":"0"}
                  }),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_ProductConfigurationSummaryItem, {
                      label: _ctx.$t('common.forms.lblPhoneNumber')
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("a", {
                          href: `tel:${_ctx.vm.booking?.expertPhoneNumber}`
                        }, _toDisplayString(_ctx.vm.booking?.expertPhoneNumber), 9, _hoisted_36)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_ProductConfigurationSummaryItem, {
                      content: _ctx.vm?.booking?.expertEmail,
                      label: _ctx.$t('common.forms.lblEmail')
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("a", {
                          href: `mailto:${_ctx.vm.booking?.expertEmail}`
                        }, _toDisplayString(_ctx.vm.booking?.expertEmail), 9, _hoisted_37)
                      ]),
                      _: 1
                    }, 8, ["content", "label"])
                  ])
                ])
              ]),
              _: 1
            })),
        _createVNode(_component_Panel, {
          class: "mb-2",
          toggleable: false
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.$t("expert.booking.projectDescription")), 1)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.vm?.booking?.projectDescription), 1)
            ])
          ]),
          _: 1
        }),
        (_ctx.isExpert && !_ctx.vm?.booking?.isRemote && _ctx.vm?.booking?.expertCosts.singleTravelDistance)
          ? (_openBlock(), _createBlock(_component_Panel, {
              key: 2,
              class: "mb-2",
              toggleable: false
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.$t("expert.booking.workLocation")), 1)
                  ]),
                  (_ctx.isExpert)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-primary",
                        icon: "pi pi-directions",
                        label: _ctx.$t(`expert.button.routeDescription`),
                        onClick: _ctx.openRouteDescription
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ProductConfigurationSummaryItem, {
                      content: _ctx.vm?.booking?.workLocation,
                      label: _ctx.$t('common.forms.lblAddress')
                    }, null, 8, ["content", "label"]),
                    _createVNode(_component_ProductConfigurationSummaryItem, {
                      content: `${_ctx.vm?.booking?.expertCosts.singleTravelDistance} ${_ctx.$t('common.kilometer')}`,
                      label: _ctx.$t('expert.booking.distance')
                    }, null, 8, ["content", "label"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_GMapMap, {
                    center: { lat: _ctx.vm?.booking?.latitude, lng: _ctx.vm?.booking?.longitude },
                    zoom: 16
                  }, null, 8, ["center"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.expertStore.isAcceptBookingModalVisible)
      ? (_openBlock(), _createBlock(_component_ExpertAcceptBookingModal, {
          key: 0,
          onSubmit: _ctx.acceptBooking
        }, null, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.expertStore.isCompleteBookingModalVisible)
      ? (_openBlock(), _createBlock(_component_ExpertCompleteBookingModal, {
          key: 1,
          onSubmit: _ctx.completeBooking
        }, null, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.expertStore.isCancelOrDeclineBookingModalVisible)
      ? (_openBlock(), _createBlock(_component_ExpertDeclineBookingModal, {
          key: 2,
          type: _ctx.declineOrCancelModalType,
          onSubmit: _ctx.declineOrCancelBooking
        }, null, 8, ["type", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.expertStore.isBookingReviewModalVisible)
      ? (_openBlock(), _createBlock(_component_ExpertReviewBookingModal, {
          key: 3,
          onSubmit: _ctx.reviewBooking
        }, null, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.expertStore.isBookingReviewDetailsModalVisible)
      ? (_openBlock(), _createBlock(_component_ExpertReviewBookingDetailsModal, {
          key: 4,
          vm: _ctx.vm.booking.expertBookingReview
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}